export default "__VITE_ASSET__CyA1W28Z__"